module.exports = __webpack_public_path__ + "assets/img/mecha-btn-2aae50e6.png";